import { render, staticRenderFns } from "./heroThree.vue?vue&type=template&id=4cca0fb3&"
import script from "./heroThree.vue?vue&type=script&lang=js&"
export * from "./heroThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports